/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import Helmet from "react-helmet";
import SimpleReactLightbox from 'simple-react-lightbox';
import { useI18next } from "gatsby-plugin-react-i18next";

// Favicon
//import Favicon from "~images/favicon.ico";

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// Font awesome
import '~assets/library/fontawesome/css/all.min.css';

// Linea icons
import '~assets/library/linea/arrows/styles.css';
import '~assets/library/linea/basic/styles.css';
import '~assets/library/linea/ecommerce/styles.css';
import '~assets/library/linea/software/styles.css';
import '~assets/library/linea/weather/styles.css';

// Animate
import '~assets/library/animate/animate.css';

// Modal video
import 'react-modal-video/css/modal-video.min.css';

// Stylesheet
import '~assets/css/style.css';
import '~assets/css/media.css';
import CookieConsent from '../CookieConsent';

// Add dynamic CSS
const addStyleSheet = (path: string) => {
	if (typeof window === 'object') {
		const head = document.head;
		const link = document.createElement("link");

		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = path;

		head.appendChild(link);
	}
}

// Layout
const Layout = (props: {pageTitle: string, colorSchema: string, children: React.ReactNode }) => {

	const { t, i18n } = useI18next();

	// Google web font
	addStyleSheet("https://fonts.googleapis.com/css?family=Roboto:200,300,400,500,700");

	// Color schema
	addStyleSheet(props.colorSchema);

	return (
		<div>
			
			<Helmet htmlAttributes={{lang:i18n.resolvedLanguage}}>

				{/* Meta */}
				<meta charSet="utf-8" />
				<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />

				{/* Title */}
				<title>{props.pageTitle}</title>
                <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml" />

				{/* Meta Info */}
				<meta content={t("pageDescription")!} name="description"/>
				
				<meta content={t("pageTitle")!} property="og:title"/>
				<meta content={t("pageDescription")!} property="og:description"/>
				<meta content="/images/smartbooking365-logo.png" property="og:image"/>

				<meta content={t("pageTitle")!} property="twitter:title"/>
				<meta content={t("pageDescription")!} property="twitter:description"/>
				<meta content="/images/smartbooking365-logo.png" property="twitter:image"/>
				<meta property="og:type" content="website"/><meta content="summary_large_image" name="twitter:card"/>

				{/* Favicon */}
				<link rel="icon" type="image/svg+xml" href="/favicon.svg" />

				{/* Apple Touch Icons */}
				<link rel="apple-touch-icon" href="/apple-touch-icon-iphone-60x60.png" />
				<link rel="apple-touch-icon" sizes="60x60" href="/apple-touch-icon-ipad-60x60.png" />
				<link rel="apple-touch-icon" sizes="114x114" href="/apple-touch-icon-iphone-retina-114x114.png" />
				<link rel="apple-touch-icon" sizes="144x144" href="/apple-touch-icon-ipad-retina-144x144.png" />
				<link rel="apple-touch-icon" sizes="192x192" href="/apple-touch-icon-iphone-retina-192x192.png" />
				<link rel="apple-touch-icon" sizes="801x801" href="/apple-touch-icon-iphone-retina-high.png" />

				<link rel='mask-icon' href='/apple-masked-icon.svg' color='white'></link>

			</Helmet>

            <CookieConsent />
			<SimpleReactLightbox>
				{props.children}
			</SimpleReactLightbox>		

		</div>
	);
}

export default Layout;